import React from 'react';
import { Link } from 'react-router-dom';
import Pages from './Pages.js';
// import BarLoader from 'react-spinners/ClipLoader';
// import { CSSRef } from '../components/CSSRef';





class Contribution extends Pages {
  componentDidMount() {
    window.scrollTo(0, 0)
    // setTimeout(function () {
    //   this.setState({ isLoading: false });
    // }.bind(this), 5000);
  }

  leftmenu = () => {
    return (

      <div className='leftmenu'>
        <div>Contribution</div>
        <br />
        <button onClick={() => this.scroll(this.firstRef)} className={'section'}> Overview </button>
        <button onClick={() => this.scroll(this.secondRef)} className={'section'}> Plasmid Design and Construction</button>
        <button onClick={() => this.scroll(this.thirdRef)} className={'section'}>Parts Improvement </button>
        <button onClick={() => this.scroll(this.fourthRef)} className={'section'}> Education </button>
      </div>
    )
  }

  righttext = () => {
    return (
      <div className='righttext'>
        <div ref={this.firstRef}>
          In an effort to produce an effective answer to the challenge of antimicrobial resistance in aquaculture, our team developed an intricately layered project. Split up into different phases, we aimed to first test the final product in vitro, comprising the transgenic microalgae encapsulating the cleaved and active Cecropin B, and then produce the same. Over the course of our project designing and development, we’ve realized that a team may not be able to execute all aspects of this stratified venture. As a consequence, we have made available all detailed information regarding our project to support any team that may choose to take up the same.
        </div>
        <br /><br />

        <h2 ref={this.secondRef}>Plasmid Design and Construction</h2>
        <div>
          <br />
          Our plasmid design and construction has been supplemented with the addition of the relevant parts to the iGEM Registry. Furthermore, a pool of referenced literature, spanning topics from AMR, AMPs and Microalgae (C. vulgaris var. autotrophica), experimental designs, and protocols as have been documented within the open source wiki can help future researchers gain insight into the work conducted by our team for their own application. In particular, our work on Phase 0 or the pilot of our project, which enabled us to successfully prove the SUMO-cleavage and double-His Tag purification, as well as our troubleshooting in the subsequent steps may significantly enrich understanding.
        </div>
        <br /><br />
        <h2 ref={this.thirdRef}>Parts Improvement</h2>
        <div>
          <br />
          In addition to submitting new parts utilized by our team to the iGEM Registry, we have attempted to improve the functioning of an existing part. We analyzed the part BBa_K3815000, contributed by the iGEM 2021 Kyoto Team, coding for ELK16, Mxe GyrA intein, and PT linker as a component of the ELK16 purification system. Upon closer examination we discovered that there were a few errors in the sequence and that the sequence annotation in the part description was reversed. In order to rectify both aspects, we created a modified part, BBa_K4241018, which was successfully tested for its efficient functioning in Phase 0 of our current venture. We have subsequently uploaded this revised part to the registry for future teams to refer to and adopt.
        </div>
        <br /><br />
        <h2 ref={this.fourthRef}>Education</h2>
        <div>
          <br />
          The content slides designed for our synthetic biology workshop and the bioinformatics workshop were created to ensure science education is accessible to all high school students. The targeted audience of both workshops are slightly different. For the bioinformatics workshop, we targeted students from form 3/grade 8/year 9. Thus the slides we developed for this particular cohort are more general and interactive, allowing students to better understand the basics of bioinformatics as well as python. For synthetic biology, the students who attended are slightly older. Most of the students who participated were from their final years of highschool. Hence, we incorporated more advanced concepts that can hopefully challenge and inspire the students interest in synthetic biology. We understand how difficult it is for educators and students to learn about synthetic biology and bioinformatics, due to the limited information online. Nonetheless, as both workshops received very positive reviews, we would like to share our tools to facilitate the teaching and learning of synthetic biology and bioinformatics to our fellow educators and students.
          <br /><br />
          <Link to='/education'>Click here to view the slides!</Link>
        </div>
      </div>
    )
  }

  render() {
    return (
      <>
        {/* {this.state.isLoading ? <div className='load-container'><BarLoader color={'silver'} size={150} loading={this.state.isLoading} cssOverride={CSSRef} /></div> : null} */}

        <h1 className='des'>Contribution</h1>
        <div className='pageholder'>

          {this.leftmenu()}
          {this.righttext()}
        </div>
      </>
    )
  }
}


export default Contribution;
